<template>
  <div class="com">
    <div class="title">
      Before You Go...
    </div>
    <div class="subtitle">
      We have a few quick questions for you. In the areas where you collected
      samples…
    </div>
    <div class="question-wrap">
      <div class="question">
        Is there a visible mold?
      </div>
      <div class="checkbox-items-wrap">
        <div class="label-checkbox">
          <div class="checkbox-wrap">
            <label
              for="check1"
              class="checkbox-toggle-text"
              :class="{ 'checkbox-toggle-text-right': !visible_mold }"
              >{{ visible_mold ? "Yes" : "No" }}</label
            >
            <input
              type="checkbox"
              class="checkbox"
              id="check1"
              v-model="visible_mold"
            />
            <span class="slider"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="question-wrap">
      <div class="question">
        Is there a "musty" or a "damp" odor?
      </div>
      <div class="checkbox-items-wrap">
        <div class="label-checkbox">
          <div class="checkbox-wrap">
            <label
              for="check2"
              class="checkbox-toggle-text"
              :class="{ 'checkbox-toggle-text-right': !musty_damp_odor }"
              >{{ musty_damp_odor ? "Yes" : "No" }}</label
            >
            <input
              type="checkbox"
              class="checkbox"
              id="check2"
              v-model="musty_damp_odor"
            />
            <span class="slider"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="question-wrap">
      <div class="question">
        Is anyone experiencing symptoms that you think might be mold-related?
      </div>
      <div class="checkbox-items-wrap">
        <div class="label-checkbox">
          <div class="checkbox-wrap">
            <label
              for="check3"
              class="checkbox-toggle-text"
              :class="{ 'checkbox-toggle-text-right': !symptoms }"
              >{{ symptoms ? "Yes" : "No" }}</label
            >
            <input
              type="checkbox"
              class="checkbox"
              id="check3"
              v-model="symptoms"
            />
            <span class="slider"></span>
          </div>
        </div>
      </div>
    </div>
    <button class="btn" @click="sendData">Continue</button>
    <button class="back-btn" @click="skipData">Skip</button>
    <p class="text-bottom">
      This information is for research purposes only and will not appear in your
      report. Your responses are anonymous and protected by our
      <span
        @click="showPrivacy"
        @click.stop="stopPropagation"
        class="terms-link"
        >privacy policy.</span
      >
      Your input helps us create better solutions.
    </p>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "FinalStep",
  data() {
    return {
      visible_mold: false,
      musty_damp_odor: false,
      symptoms: false
    };
  },
  methods: {
    ...mapActions(["sendFinalData"]),
    sendData() {
      const data = {
        kit_id: this.$store.getters.kit,
        kit_id_confirmation: this.$store.getters.kit,
        visible_mold: this.visible_mold,
        musty_damp_odor: this.musty_damp_odor,
        symptoms: this.symptoms
      };
      this.sendFinalData(data).then(res => {
        if(this.$route.path != "/home") {
          this.$router.push("/home");
        }else{
          this.$emit("reRenderHome");
        }
      });
    },
    skipData() {
      const data = {
        kit_id: this.$store.getters.kit,
        kit_id_confirmation: this.$store.getters.kit,
        visible_mold: null,
        musty_damp_odor: null,
        symptoms: null
      };
      this.sendFinalData(data).then(res => {
        if(this.$route.path != "/home") {
          this.$router.push("/home");
        }else{
          this.$emit("reRenderHome");
        }
      });
    },
    showPrivacy() {
      //this.$emit("showTerms", true);
      this.$emit("showPrivecy", true);
    },
    stopPropagation(event) {
      event.stopPropagation();
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.checkbox-items-wrap {
  display: flex;
  justify-content: center;
}
.label-checkbox {
  display: flex;
  align-items: center;
  position: relative;
}
.checkbox {
  opacity: 0;
  width: 100%;
  margin: 0;
  height: 100%;
  z-index: 1;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
}
.checkbox-wrap {
  position: relative;
  width: 72px;
  height: 24px;
}

.checkbox-toggle-text {
  position: absolute;
  z-index: 2;
  color: $white;
  font-size: 11px;
  text-transform: uppercase;
  font-family: TTNormsMedium, sans-serif;
  top: 9px;
  left: 15px;
  cursor: pointer;
}
.checkbox-toggle-text-right {
  left: auto;
  right: 15px;
}
.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  width: 100%;
  height: 100%;
  border-radius: 20px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 28px;
  width: 28px;
  left: 0;
  bottom: -2px;
  box-shadow: 0 0 2px 1px $boxShadow;
  background-color: $white;
  transition: 0.4s;
  border-radius: 100%;
}
.checkbox:checked + .slider {
  background-color: $green;
}

.checkbox:checked + .slider:before {
  transform: translateX(44px);
}
.title {
  color: #005eb8;
  font-size: 27px;
  margin: 0 0 30px 0;
  text-align: center;
  font-family: TTNormsBold, sans-serif;
}
.subtitle {
  text-align: center;
  font-size: 16px;
  font-family: TTNormsRegular, sans-serif;
  width: 100%;
  margin: 0 auto 20px auto;
  line-height: 1.3;
}
.text-bottom {
  text-align: center;
  font-size: 14px;
  margin-top: 36px;
  font-family: TTNormsRegular, sans-serif;
  line-height: 18px;
}
.terms-link {
  color: $blue;
  font-size: 14px;
  line-height: 18px;
  font-family: TTNormsRegular, sans-serif;
  cursor: pointer;
}
.question-wrap {
  margin: 0 0 32px 0;
}
.question {
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  text-align: center;
  margin: 0 0px 15px 0;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: none;
  height: 45px;
  border-radius: 25px;
  max-width: 300px;
  transition: all 0.5s linear;
  font-size: 18px;
  font-family: TTNormsBold, sans-serif;
}
.back-btn {
  color: $green;
  border: none;
  cursor: pointer;
  outline: none;
  display: block;
  margin: 36px auto 0 auto;
  background-color: transparent;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}
</style>
